import util from "../../../util";

const loadLowRequests = ({ commit } , payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader();

    const url = `lows/${payload.idClient}?${payload.params}`;

    payload.context.axios.get(url, { headers }).then((response) => {
      resolve(response.data);
    }).catch(error => {
      util.showDialogError(payload.context, 'Error al cargar las solicitudes de baja');
      reject(error);
    });
  });
};

const createLowRequest = ({ commit }, payload) => {
  // payload debe tener:
  // payload.type -> 'files' o 'boxes'
  // payload.data -> El objeto que se enviará en el body del POST

  const url = `/lows/${payload.type}`;

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader();
    payload.context.axios.post(url, payload.data, { headers })
      .then(response => {
        resolve(response.data);
      }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al enviar la solicitud.');
      reject(error);
    });
  });
};

export default {
  loadLowRequests,
  createLowRequest,
}



// WEBPACK FOOTER //
// ./src/store/modules/low/actions.js